__turbopack_context__.v({
  "className": "JkbZVW_className",
  "variable": "JkbZVW_variable",
});
